import { apiWrapper } from "@/services/api";
import store from "@/store";

export const getMyticketDetail = async (book_group_id) => {
  try {
    const resp = await apiWrapper(
      "GET",
      `my-ticket-detail/?book_group_id=${book_group_id}`
    );
    store.commit("ticketing/setbookGroup", resp.data);
    store.commit("ticketing/setMasterBook", resp.data._master_book);
    store.commit("ticketing/setBook", resp.data.books[0]);
    return resp.data;
  } catch (err) {
    console.log('ERROR"" getMyticketDetail()', err);
    throw err;
  }
};
